import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import usePromise from 'react-use-promise';
import Loading from './Loading';
import { REJECTED, RESOLVED } from './constants';

var LoadingStepsWrapper = _styled("div", {
  target: "ej267es0",
  label: "LoadingStepsWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ba0hib",
  styles: "width:30%;height:90vh;display:flex;flex-direction:column;justify-content:center;margin:auto;"
} : {
  name: "ba0hib",
  styles: "width:30%;height:90vh;display:flex;flex-direction:column;justify-content:center;margin:auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
/**
 * Component to evaluate all the promises resolved
 */


var PreviewComponent = function PreviewComponent(_ref) {
  var templateQuery = _ref.templateQuery,
      pageContext = _ref.pageContext,
      component = _ref.component,
      data = _ref.data;
  var allReady = templateQuery[STATUS] === RESOLVED && pageContext[STATUS] === RESOLVED && component[STATUS] === RESOLVED && data[STATUS] === RESOLVED;
  var externalError = templateQuery[STATUS] === REJECTED || pageContext[STATUS] === REJECTED || component[STATUS] === REJECTED || data[STATUS] === REJECTED;

  if (allReady) {
    var Component = component[RESULT]["default"];
    return /*#__PURE__*/React.createElement(Component, {
      pageContext: pageContext[RESULT].context,
      data: data[RESULT].data
    });
  } else {
    return /*#__PURE__*/React.createElement(LoadingStepsWrapper, null, /*#__PURE__*/React.createElement(Loading, {
      message: "Looking for Page Template",
      status: templateQuery[STATUS],
      error: templateQuery[ERROR],
      externalError: externalError
    }), /*#__PURE__*/React.createElement(Loading, {
      message: "Procesing Page Context",
      status: pageContext[STATUS],
      error: pageContext[ERROR],
      externalError: externalError
    }), /*#__PURE__*/React.createElement(Loading, {
      message: "Loading Template Component",
      status: component[STATUS],
      error: component[ERROR],
      externalError: externalError
    }), /*#__PURE__*/React.createElement(Loading, {
      message: "Loading Data for Template",
      status: data[STATUS],
      error: data[ERROR],
      externalError: externalError
    }));
  }
};

var RESULT = 0,
    ERROR = 1,
    STATUS = 2;
/**
 * Component to inject graphql queries in a component with a loader
 * @param {object} param0
 * @param {string} param0.slug
 * @param {object} param0.queries
 * @param {object} param0.pageContextFactory
 * @param {object} param0.client Apollo Client Object
 * @param {object} param0.clients Apollo Client Objects by source name
 * @param {object} param0.TEMPLATE_QUERY Graphql Document object
 * @param {Promise} importFunction Promise wrapping the import() context
 */

export var Preview = function Preview(_ref2) {
  var slug = _ref2.slug,
      queries = _ref2.queries,
      pageContextFactory = _ref2.pageContextFactory,
      client = _ref2.client,
      clients = _ref2.clients,
      TEMPLATE_QUERY = _ref2.TEMPLATE_QUERY,
      importFunction = _ref2.importFunction;
  var templateQuery = usePromise(function () {
    return client.query({
      query: TEMPLATE_QUERY,
      variables: {
        slug: slug
      },
      fetchPolicy: 'no-cache'
    }).then(function (_ref3) {
      var data = _ref3.data;
      var template = Object.entries(data).find(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            template = _ref5[1];

        return template !== null;
      });
      return template || Promise.reject(new Error('Preview not found'));
    });
  }, []); //First we need to look for all posible templates and create the page context

  var pageContext = usePromise(function () {
    if (templateQuery[STATUS] === RESOLVED) {
      var _templateQuery$RESULT = _slicedToArray(templateQuery[RESULT], 2),
          key = _templateQuery$RESULT[0],
          value = _templateQuery$RESULT[1];

      var _pageContext = pageContextFactory[key](value, key);

      return _pageContext.then !== undefined ? _pageContext : Promise.resolve(_pageContext);
    }
  }, [templateQuery[STATUS], templateQuery[RESULT]]);
  var component = usePromise(function () {
    if (pageContext[STATUS] === RESOLVED) {
      var _component = pageContext[RESULT].component.replace('/src/', '');

      return importFunction(_component);
    }
  }, [pageContext[STATUS], pageContext[RESULT]]); //Now we can look for the data needed for the template

  var data = usePromise(function () {
    if (pageContext[STATUS] === RESOLVED && component[STATUS] === RESOLVED) {
      var queriesTemplate = queries[pageContext[RESULT].component];
      return Promise.all(Object.entries(queriesTemplate).map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            query = _ref7[1];
        /**
         * @type {Array}
         */


        var varNames = query.definitions.map(function (definition) {
          if (definition.kind === 'OperationDefinition') {
            return definition.variableDefinitions.map(function (variableDefinition) {
              return variableDefinition.variable.name.value;
            });
          }

          return [];
        });
        var variables = {};
        varNames.flat().forEach(function (varName) {
          return variables[varName] = pageContext[RESULT].context[varName];
        });
        variables.preview = true;
        return clients[key].query({
          query: query,
          variables: variables,
          fetchPolicy: 'no-cache'
        });
      })).then(function () {
        var dataArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return dataArray.reduce(function (current, next) {
          return _objectSpread(_objectSpread({}, current), next);
        }, {});
      });
    }
  }, [pageContext[STATUS], component[STATUS], pageContext[RESULT], queries]);
  return /*#__PURE__*/React.createElement(PreviewComponent, {
    templateQuery: templateQuery,
    pageContext: pageContext,
    component: component,
    data: data
  });
};